module.exports = __webpack_public_path__ + "img/go-back-button.8b8a82e4.svg";